// extracted by mini-css-extract-plugin
module.exports = {"functionBadge":"styles_functionBadge__48lLO","functionRow":"styles_functionRow__shVa2"};